import { Link, useNavigate } from 'react-router-dom';
import styled from 'styled-components/macro';
import { WxText } from '../..';
import {
  OrderCardType,
  orderStatuses,
} from '../../../hooks/api/queries/useOrders';
import { __ } from '../../../i18n/l10n';
import { breakpoint } from '../../../styles/constants';
import { SLUG_ORDER } from '../../../styles/slugs';
import { appendCommitHash } from '../../../utils/appendHash';
import { getDateFormatted } from '../../../utils/getDateFormatted';
import { splitNumber } from '../../../utils/splitNumber';
import { WImage } from '../../ui/image/Image';

interface Props {
  order: OrderCardType;
}
export const OrderCard = ({ order }: Props) => {
  const navigate = useNavigate();

  return (
    <Wrapper>
      <ImageDiv
        onClick={() => navigate(appendCommitHash(`/${SLUG_ORDER}/${order.id}`))}
      >
        <WImage
          image={
            order.localizedVariantImage ??
            order.defaultVariantImage ??
            order.localizedProductImage ??
            order.defaultProductImage
          }
          background
        />
      </ImageDiv>
      <InfoDiv>
        <TopDiv>
          <WxText darkMode text={orderStatuses[order.status]} bold uppercase />
        </TopDiv>
        <MiddleDiv>
          <WxText darkMode text={`${__('Order')}: \n${order.id.toString()}`} />
          <WxText darkMode text={getDateFormatted(order.createdAt)} />
        </MiddleDiv>
        <BottomDiv>
          <Link to={appendCommitHash(`/${SLUG_ORDER}/${order.id}`)}>
            <RedLink>{__('Track order')}</RedLink>
          </Link>
          <WxText
            darkMode
            text={`${splitNumber(order.totalMilesAmount)} ${__('MILES')}`}
            bold
          />
        </BottomDiv>
      </InfoDiv>
    </Wrapper>
  );
};

export const RedLink = styled.span`
  color: ${({ theme }) => theme.colors.red};
  text-decoration: underline;
  text-decoration-color: ${({ theme }) => theme.colors.red};
  text-underline-offset: 1px;
  font-weight: 700;
  font-size: 0.75rem;

  @media (min-width: ${breakpoint}) {
    font-size: 0.875rem;
  }
  cursor: pointer;
`;

const Wrapper = styled.div`
  display: flex;
  gap: 0.625rem;
  padding-bottom: 1.2rem;
  border-bottom: 1px solid ${({ theme }) => theme.colors.darkgray};
`;

const InfoDiv = styled.div`
  width: calc(66% - 0.3125rem);
  display: flex;
  flex-direction: column;
  padding-top: 0.625rem;
`;

const TopDiv = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 0.9575rem;

  > :last-child {
    display: flex;
    gap: 0.8125rem;
    margin-right: 0.5rem;
    font-size: 0.75rem;
  }
`;

const BottomDiv = styled.div`
  margin-top: auto;
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
`;

const MiddleDiv = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.625rem;
  text-align: left;
  margin-top: 0.625rem;
`;

const ImageDiv = styled.div`
  width: calc(34% - 0.3125rem);
  cursor: pointer;
  @media (min-width: ${breakpoint}) {
    width: 43%;
  }
`;
